import { httpRequest } from "@services/http";

export class CommandDeleteAdGroup {
  async run(launchId: number, adGroupId: number): Promise<void> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/launches/${launchId}/ad-groups/${adGroupId}/`;
    await httpRequest<null>(url, { method: "DELETE" });
  }
}
